import Axios from "axios";
import {clearFeedbacksByName} from "../../helpers/forms";
import handleAjaxError from "../../helpers/handleAjaxError";
import {toUrl} from "../../helpers/url";

let form = null;
let dropZone = null;
let fileInput = null;
let imagePreview = null;
let fileToUpload = null;
let post = null;
let isCustomerView = false;
let project = null;
let categorySelector = null;

const fields = [
	'title',
	'body',
	'category_id',
	'visibility_id',
	'project_id',
]

function initDesignBoard(_isCustomerView = false) {

	isCustomerView = _isCustomerView;

	form = document.getElementById('postForm');
	form.querySelector('.submit').onclick = savePost;

	fileInput = form.querySelector('input[type=file]');
	fileInput.onchange = handleFileChange;

	form.querySelector('.uploadImage').onclick = handleImageUpload;

	dropZone = form.querySelector('.drop-zone');
	dropZone.ondrop = handleDrop;
	dropZone.ondragover = handleDropOver;
	dropZone.ondragleave = handleDropLeave;

	imagePreview = form.querySelector('img');

	categorySelector = form.querySelector('select[name=category_id]');

	if (window.post) {
		post = window.post;
	}

	if (window.project) {
		project = window.project;
		filterCategories(project.id);
	}

	if (!isCustomerView) {
		form.querySelector('select[name=project_id]').onchange = e => filterCategories(e.target.value);
	} else {
		// customer view categories by project
		filterCategories(project.id);
	}

}

function filterCategories(projectId) {
	if (projectId) {
		// noinspection JSUnresolvedVariable
		const projectCategories = window.projects_categories[projectId].categories;
		Array.from(categorySelector.children).forEach(option => {
			if (option.value) {
				// Ignore "No category" entry
				let isProjectCategory = false;
				projectCategories.forEach(category => {
					// noinspection EqualityComparisonWithCoercionJS
					if (category.id == option.value) {
						isProjectCategory = true;
					}
				})
				if (isProjectCategory) {
					option.disabled = false;
					option.hidden = false;
				} else {
					option.disabled = true;
					option.hidden = true;
					option.selected = false;
				}
			}
		});
	} else {
		Array.from(categorySelector.children).forEach(option => {
			if (option.value) {
				// Ignore "No category" entry
				option.disabled = false;
				option.hidden = false;
			}
		});
	}
}

function handleImageUpload() {
	fileInput.click();
}

function handleDrop(event) {
	event.preventDefault();

	let file = null;
	if (event.dataTransfer.items) {
		// Use DataTransferItemList interface to access the file(s)
		const item = event.dataTransfer.items[0];
		if (item.kind === 'file') {
			file = item.getAsFile();
		}
	} else {
		// Use DataTransfer interface to access the file(s)
		file = event.dataTransfer.files[0];
	}

	if (file) {
		let fr = new FileReader();
		fr.onload = function () {
			imagePreview.src = fr.result;
			imagePreview.parentElement.classList.remove('d-none');
			dropZone.classList.remove('file-hover');
		}
		fr.readAsDataURL(file);
		fileToUpload = file;
	}

}

function handleDropOver(event) {
	event.preventDefault();
	dropZone.classList.add('file-hover')
}

function handleDropLeave(event) {
	event.preventDefault();
	dropZone.classList.remove('file-hover');
}

function handleFileChange() {
	if (fileInput.files[0]) {
		fileToUpload = fileInput.files[0];

		let fr = new FileReader();
		fr.onload = function () {
			imagePreview.src = fr.result;
			imagePreview.parentElement.classList.remove('d-none');
			dropZone.classList.remove('file-hover');
		}
		fr.readAsDataURL(fileToUpload);
	}
}

function savePost() {
	const data = new FormData(form)

	if (fileToUpload) {
		data.append('image', fileToUpload);
	}
	data.delete('tempFileHolder');

	let url;

	if (isCustomerView) {
		url = toUrl(`/design-board/${project.id}`);
		if (post) {
			// Editing a post
			url = toUrl(`/design-board/${project.id}/post/${post.id}`)
			data.append('_method', 'PUT');
		}
	} else {
		url = toUrl(`/admin/design-board`);
		if (post) {
			// Editing a post
			url = toUrl(`/admin/design-board/${post.id}`)
			data.append('_method', 'PUT');
		}
	}

	clearFeedbacksByName(form, fields);
	loading();

	Axios.post(url, data)
		.then(response => {
			// noinspection JSUnresolvedVariable
			Swal.fire({
				icon: 'success',
				text: response.data.message,
				timer: 2000,
			}).then(() => {
				loading();
				if (post) {
					window.location.reload();
				} else {
					// noinspection JSUnresolvedVariable
					window.location = response.data.postUrl;
				}
			});
		})
		.catch(handleAjaxError)
		.finally(stopLoading);
}

export {
	initDesignBoard
}
